import { aiDashboardAssets } from '../configs/constants';
import axios, { isCancelRequest, buildRequestCancelation } from '../../../configs/axios';

const BASE_URL = '/ai_dashboard';

// AI DASHBOARD
const {
  apps,
  financeApps,
  marketOverview,
  timeSpentPenetration,
  usageTrends,
  usageTransitions,
  segmentConcentration,
  sectorsStats,
  aiAppTrends,
  segmentTransitions,
  aiAppImpact,
} = aiDashboardAssets;

const fetchAiDashboardData = (requestParams) => {
  const decorateParams = (paramsDecorator) => ({
    ...requestParams,
    params: paramsDecorator(requestParams.params),
  });

  switch (requestParams.params.asset) {
    case apps:
      return axios.get(`${BASE_URL}/apps.json`);
    case financeApps: {
      const decoratedParams = decorateParams((params) => params.filters);
      return axios.get(`${BASE_URL}/finance_apps_search.json`, decoratedParams);
    }
    case usageTransitions:
    case segmentTransitions:
    case usageTrends:
    case sectorsStats:
    case marketOverview:
    case timeSpentPenetration:
    case aiAppTrends:
    case segmentConcentration:
    case aiAppImpact: {
      const decoratedParams = decorateParams((params) => ({
        asset_name: requestParams.params.asset,
        ...params.filters,
      }));
      return axios.get(`${BASE_URL}/data.json`, decoratedParams);
    }

    default:
      return Promise.resolve();
  }
};

const buildExportUrl = (slug) => `${BASE_URL}/${slug}`;

export default {
  axios,
  isCancelRequest,
  buildRequestCancelation,
  fetchAiDashboardData,
  buildExportUrl,
};
